import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {TextField,
        InputAdornment,
        Button,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        Checkbox,
        FormControlLabel,
        Chip,
        CircularProgress
} from "@material-ui/core";
import {
    Message as MessageIcon
} from '@material-ui/icons'

import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';

const JobReportEmail = forwardRef((props, ref) => {
    const { closeMenu } = props;
    const classes = useStyles();
    const [email, setEmail] = useState({...props.email});
    var [openEmail, setOpenEmail] = React.useState(false);
    var [emailAddressesValue, setEmailAddressesValue] = React.useState('');
    const emailAddressesInputRef = React.useRef(null);
    var emailAddressInputValue = '';
    const [chips, setChips] = useState([]);
    const [isCurrentEmailValid, setIsCurrentEmailValid] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

    useImperativeHandle(ref, () => ({

      openEmail(selectedEmail) {
        setChips(selectedEmail.emails);
        setEmail(selectedEmail);
        handleClickOpenEmail();
      }

    }));

    useEffect(() => {
      setEmail({
        ...email,
        emails: chips
      });
    },[chips]);



    const handleClickOpenEmail = () => {
      closeMenu();
      setOpenEmail(true);
    };

    const handleCloseEmail = () => {
      clearEmail();
      setOpenEmail(false);
    };

    const handleSendEmail = async () => {
        setIsSending(true);
        const response = await ttAPI.emailJobReport(email);
        if (response) {
            sendNotification('success', `Email Sent to ${email.emails.join()} successfully.`, classes);
            clearEmail();
            setIsSending(false);
            setOpenEmail(false);
        }
        else {
            setIsSending(false);
            sendNotification('error', `Error - failed to send email to ${email.emails.join()}.`, classes );
        }

    };

    function clearEmail() {
        setEmail({
            job_id: -1,
            emails: [],
            customer_name: '',
            message: '',
            attach_certificate: true,
            attach_invoice_report: true,
            date: ''
        });
        setChips([]);
    };


    function handleChangeMessage(e) {
      setEmail({
          ...email,
          message: e.target.value
      });
    }

    function handleAttachCertificateChecked(e) {
      setEmail({
          ...email,
          attach_certificate: e.target.checked
      });
    }

    function handleAttachInvoiceReportChecked(e) {
      setEmail({
          ...email,
          attach_invoice_report: e.target.checked
      });
    }

    const handleKeyDownOnEmailAddressInput = (e) => {
       // tab/enter/space/semi-olon/comma
       if(e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 186 || e.keyCode === 188) {
         if (isEmailValid(emailAddressInputValue)) {
           //console.log(emailAddressInputValue);
           setChips([...chips, emailAddressInputValue]);
           //console.log(chips);
           //console.log(emailAddressesInputRef.current.value);
           setTimeout(() => {
             emailAddressesInputRef.current.value = '';
           }, 100);
           //console.log(emailAddressesInputRef.current.value);
           //console.log(emailAddressesInputRef);
         }
       }
       else if (emailAddressInputValue === '') {
         isEmailValid('');
       }
    };

    const addressesInputChange = (event) => {
      emailAddressInputValue = event.target.value;
    };

    const handleDeleteChip = (itemToDelete) => {
      setChips(chips.filter(item => item !== itemToDelete));
    };

    const onMouseDownChip = e => {
      e.stopPropagation();
    };

    const isEmailValid = (email) => {
      var isValid = email ? pattern.test(email) : true;
      setIsCurrentEmailValid(isValid);
      return isValid;
    }

  return (
    <>
    <Dialog open={openEmail} onClose={handleCloseEmail} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >


    <DialogTitle id="form-dialog-title">Email Report</DialogTitle>
    <DialogContent>
      <DialogContentText>
         Job: {email.job_id} - Customer: {email.customer_name}
      </DialogContentText>
      <FormControlLabel
        control={
          <Checkbox
            checked={email.attach_certificate}
            onChange={handleAttachCertificateChecked}
            name="attach_certificate"
            color="primary"
          />
        }
        label="Attach Certificate"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={email.attach_invoice_report}
            onChange={handleAttachInvoiceReportChecked}
            name="attach_invoice_report"
            color="primary"
          />
        }
        label="Attach Invoice Report"
      />
      <TextField
        fullWidth
        id="message"
        name="message"
        label="Message"
        autoComplete='off'
        value={email.message}
        multiline
        rows="5"
        variant="outlined"
        onChange={handleChangeMessage}
        style={{ marginBottom: 35 }}
        InputProps={{
          className: classes.textarea,
          startAdornment: (
            <InputAdornment position="start">
              <MessageIcon />
            </InputAdornment>
          ),
        }}
      />
      <TextField
         fullWidth
         variant="outlined"
         label="Email Addresses"
         inputRef={emailAddressesInputRef}
         onChange={addressesInputChange}
         onKeyDown={handleKeyDownOnEmailAddressInput}
         error={!isCurrentEmailValid}
         helperText="Type in an email then press enter"
         InputProps={{
           className: classes.chipsTextfield,
           startAdornment: chips.map((item) => (
             <Chip
               className={classes.textfieldChip}
               key={item}
               label={item}
               onDelete={() => handleDeleteChip(`${item}`)}
               //onMouseDown={onMouseDownChip}

             />
           )),
         }}
       />
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseEmail}>
        Cancel
      </Button>

        <Button variant="contained" color="primary"
                className={classes.sendButton}
                onClick={handleSendEmail} disabled={isSending || (!isCurrentEmailValid || email.emails.length <= 0)}>
          {isSending && <span><CircularProgress size={25}/> Sending...</span>}
          {!isSending && <span>Send</span>}
        </Button>


    </DialogActions>
    </Dialog></>
  );
});
export default JobReportEmail;
